export default __webpack_public_path__ + "static/media/009-waist.c99d823d.svg";